import { FC } from 'react';
import { Box, ClickAwayListener, Typography } from '@mui/material';
import { t } from 'i18next';

const pdfFormat = 'pdf';
const unsupportedFormats = ['doc', 'docx'];

interface ImagePreviewProps {
  src: string;
  title: string;
  type: string;
  handleClose: () => void;
}

export const FilePreviewContent: FC<ImagePreviewProps> = ({
  src,
  title,
  type,
  handleClose,
}) => {
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          maxWidth: 'calc(100vw - 124px)',
          height: '100%',
          overflow: 'auto',
        }}
      >
        {unsupportedFormats.includes(type) ? (
          <Box
            sx={{
              display: 'grid',
              placeItems: 'center',
              px: 8,
              py: 6,
              background: 'common.white',
              bgcolor: 'common.white',
              borderRadius: 2,
              boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.12)',
              minWidth: 320,
            }}
          >
            <Typography variant='h6' sx={{ color: 'text.primary' }}>
              {t('common.filePreview.notSupported')}
            </Typography>
          </Box>
        ) : type === pdfFormat ? (
          <Box
            component='embed'
            src={`${src}#view=FitH&toolbar=0&navpanes=0`}
            sx={{
              height: '100%',
              width: 'calc(100vw - 124px)',
              maxWidth: '1600px',
            }}
          />
        ) : (
          <Box component='img' src={src} alt={title} />
        )}
      </Box>
    </ClickAwayListener>
  );
};
